import "./content-stats.css";

export const createContentStats = () => {};
